import { createSelector } from "@reduxjs/toolkit";

/**
 * @returns {JudgeState}
 */
export const selectUserJudge = (state) => state.userJudge;

export const selectMissions = createSelector(
  selectUserJudge,
  (state) => state.missions
);

export const selectIsLoadingMissions = createSelector(
  selectUserJudge,
  (state) => state.isLoadingMissions
);

export const selectCurrentMission = createSelector(
  selectUserJudge,
  (state) => state.currentMission
);

export const selectIsLoadingProjects = createSelector(
  selectUserJudge,
  (state) => state.isLoadingProjects
);

export const selectProjectFilter = createSelector(
  selectUserJudge,
  (state) => state.projectFilter
);

export const selectProjectPaging = createSelector(
  selectUserJudge,
  (state) => state.projectPaging
);

export const selectStages = createSelector(
  selectUserJudge,
  (state) => state.stages
);

export const selectCurrentStage = createSelector(
  selectUserJudge,
  (state) => state.currentStage
);

export const selectReviewDraft = createSelector(
  selectUserJudge,
  (state) => state.reviewDraft
);

export const selectReviewStatus = createSelector(selectUserJudge, (state) => ({
  id: state.editingProjectId,
  isDirty: state.isReviewDirty,
  isSubmitted: state.isReviewSubmitted,
}));
